import { IPAInsurance } from "./paInsurance.types";

export interface IPAInsuranceState {
  paInsuranceList: IPAInsurance[];
}

export const initialPAInsuranceState: IPAInsuranceState = {
  paInsuranceList: [],
};
